export default function isLocal() {
  return window.location.host.startsWith('localhost');
}
